import { gql } from '@apollo/client';

export const LIST_TEAM_MEMBERS = gql`
    query GetTeamMembers($teamMembersListInput: TeamMemberListInput!) {
        getTeamMembers(teamMembersListInput: $teamMembersListInput) {
            items {
                companyId
                teamMember {
                    _id
                    email
                    firstName
                    lastName
                    mobileNum
                    profileImage
                    jobTitle
                }
                jobTitleInCompany
                companyCreator
                teamMemberRole
                permissions {
                    name
                    allowed
                    acessType
                }
            }
            meta {
                totalPages
                itemCount
                totalItems
                itemsPerPage
                currentPage
            }
            totalLockedMembers
            totalUnlockedMembers
        }
    }
`;

export const GET_TEAM_MEMBER = gql`
    query GetTeamMember($teamMemberDetailInput: TeamMemberDetailInputDto!) {
        getTeamMember(teamMemberDetailInput: $teamMemberDetailInput) {
            teamMember {
                email
                firstName
                lastName
                mobileNum
                jobTitle
                profileImage
            }
            jobTitleInCompany
            permissions {
                allowed
                name
            }
            teamMemberId
            companyId
        }
    }
`;

export const GET_COMPANY_LIST = gql`
    query Query {
        userCompanyList {
            _id
            legalBusinessName
            companyLogo
        }
    }
`;

export const GET_COMPANY_LIST_CREATOR_FLAG = gql`
    query Query {
        userCompanyListWithCreatorFlag {
            _id
            legalBusinessName
            companyLogo
            hasCreatedCompany
            userId
            isInviteTeamSkipped
            isLocked
        }
    }
`;
/**Enable when monthly question notification count is required */
// export const GET_TOTAL_UNREAD_QUESTION = gql`
//     query GetTotalUnreadQuestions($companyId: String!) {
//         getTotalUnreadQuestions(companyId: $companyId) {
//             total
//         }
//         getUnseenMonthlyQuestionCount(companyId: $companyId) {
//             count
//         }
//     }
// `;

/**For now skipping the unseen monthy question count api */
export const GET_TOTAL_UNREAD_QUESTION = gql`
    query GetTotalUnreadQuestions($companyId: String!) {
        getTotalUnreadQuestions(companyId: $companyId) {
            total
        }
    }
`;

export const GET_TOTAL_QUESTIONS_FROM_EMAIL = gql`
    query GetAuthorizedUsersAndQuestion {
        getAuthorizedUsersAndQuestion {
            companyId
            type
            data
            questionCount
        }
    }
`;

export const GET_QUESTION_REGISTERY_COUNT = gql`
    query Query($companyId: String!) {
        getQuestionRegistryCount(companyId: $companyId) {
            total
            starred
            drafted
            deleted
        }
    }
`;

export const GET_FILE_URL = gql`
    query GetSignedUrlFromKey($key: String!) {
        getSignedUrlFromKey(key: $key) {
            signedUrl
            size
        }
    }
`;
export const GET_TOTAL_ENQUIRY = gql`
    query Query($companyId: String!) {
        getTotalEnquiryResponse(companyId: $companyId) {
            totalAssigned
            totalOutstanding
            totalResolved
            totalUnread
            totalArchived
            totalDrafted
            outstandingChangePercentage
            totalChangePercentage
            unreadChangePercentage
            totalQuestions
            totalSample
        }
    }
`;
export const GET_ALL_MONTHLY_QUESTIONS = gql`
    query GetAllMonthlyQuestionPrompt($body: ListMonthlyQuesitonPromptInput!) {
        getAllMonthlyQuestionPrompt(body: $body) {
            items {
                _id
                publishedDate
                question
                status
                totalCopiedTimes
            }
            meta {
                currentPage
                itemCount
                itemsPerPage
                totalItems
                totalPages
            }
        }
    }
`;
export const GET_ALL_CATEGORIES = gql`
    query GetEnquiryCategories($enquiryCategoryListInput: EnquiryCategoryListInput!) {
        getEnquiryCategories(enquiryCategoryListInput: $enquiryCategoryListInput) {
            items {
                _id
                companyId
                createdBy
                name
                categoryColor
                hoverCategoryColor
                textColor
            }
            meta {
                currentPage
                itemCount
                itemsPerPage
                totalItems
                totalPages
            }
        }
    }
`;
export const GET_TOTAL_UNREAD_NOTIFICATIONS = gql`
    query GetUnreadNotificationCount($unreadNotificationCount: UnreadNotificationInput!) {
        getUnreadNotificationCount(unreadNotificationCount: $unreadNotificationCount) {
            count
        }
    }
`;

export const GET_TEAM_MEMBERS_WITH_PERMISSION = gql`
    query GetTeamMembersWithQuestionPermission($teamMembersListInput: TeamMemberListInput!) {
        getTeamMembersWithQuestionPermission(teamMembersListInput: $teamMembersListInput) {
            _id
            lastName
            userName
            firstName
            companyCreator
            jobTitle
            profileImage
        }
    }
`;

export const GET_COMPANY_DETAILS = gql`
    query GetCompanyDetail($company: CompanyIdOnlyInput!) {
        getCompanyDetail(company: $company) {
            isInviteTeamSkipped
            teamMembers {
                userId
            }
            userId
            permissions {
                userPermissions {
                    name
                    allowed
                    acessType
                }
                teamMemberRole
                hasAdministrativeControl
                canManageQuestion
                canInviteTeamMembers
                canCreateEvent
            }
            companyLinks {
                _id
                priorityOrder
                title
                type
                url
                locked
            }
            subscription {
                activationDate
                endDate
                id
                plan
                renewable
                startDate
                status
                stripeCustomerId
                quantity
                hold
            }
            previousSubscription {
                endDate
                id
                plan
                quantity
                stripeCustomerId
            }
        }
    }
`;
export const GET_ENQUERY_HISTORY = gql`
    query GetEnquiriesHistory($enquiriesHistoryInput: GetEnquiriesHistoryInput!) {
        getEnquiriesHistory(enquiriesHistoryInput: $enquiriesHistoryInput) {
            items {
                date
                enquiries {
                    _id
                    assignees {
                        _id
                        firstName
                        lastName
                        profileImage
                        userName
                    }
                    enquiryCategories {
                        hoverCategoryColor
                        createdBy
                        companyId
                        categoryColor
                        _id
                        textColor
                        name
                    }
                    subject
                    createdAt
                }
            }
        }
    }
`;

export const MARK_ALL_AS_READ = gql`
    query MarkAllNotificationAsRead($markAllNotificationAsRead: CompanyIdInput!) {
        markAllNotificationAsRead(markAllNotificationAsRead: $markAllNotificationAsRead) {
            message
        }
    }
`;

/**Question Registery Queries */
export const GET_ALL_QUESTION_REGISTRIES = gql`
    query GetQuestionRegistries($getQuestionRegistriesInput: GetQuestionRegistriesInput!) {
        getQuestionRegistries(getQuestionRegistriesInput: $getQuestionRegistriesInput) {
            items {
                _id
                companyId
                deleted
                drafted
                lastEditedAt
                lastUpdateBy
                question
                response
                starred
            }
            hasViewedQuickResponseInfo
            totalUnlockedQuestionRegistries
            totalLockedQuestionRegistries
            meta {
                currentPage
                itemCount
                itemsPerPage
                totalItems
                totalPages
            }
        }
    }
`;
/**Get All Question Registries Ids Only (Note For Selecting All Ids When user clicks top checkbox) */
export const GET_ALL_QUESTION_REGISTRIES_IDS = gql`
    query GetQuestionRegistryIds($getQuestionRegistryIdsInput: GetQuestionRegistryIdsInput!) {
        getQuestionRegistryIds(getQuestionRegistryIdsInput: $getQuestionRegistryIdsInput) {
            questionRegistryIdsData {
                _id
                starred
            }
        }
    }
`;

/**Get User Details With Company */
export const GET_USER_DETAILS_WITH_COMPANY = gql`
    query LoggedInUserDetailWithCompanyData {
        loggedInUserDetailWithCompanyData {
            _id
            acceptedEmailCommunication
            acceptedTAndC
            acceptedWelcomeEmail
            companyCreator
            companyId
            email
            firstName
            jobTitle
            lastLoggedInAt
            lastName
            mobileNum
            plan
            profileImage
            receiveNotification
            registeredWithGoogle
            stripeCustomerId
            subscriptionRenewable
            subscriptionStatus
            userName
            verifiedAt
            isInviteTeamSkipped
            quantity
            hasViewedIntegrationModal
            hasClickedIntegrationButton
        }
    }
`;

/**GET Investor Satisfaction Response Query ***/
export const GET_INVESTOR_SATISFACTION_RESPONSE = gql`
    query InvestorSatisfaction($investorSatisfactionInput: InvestorSatisfactionInput!) {
        investorSatisfaction(InvestorSatisfactionInput: $investorSatisfactionInput) {
            notSatisfiedInvestorPercentage
            satisfiedInvestorPercentage
            total
            changedPercentageMonthly
            notSatisfied
            satisfied
        }
    }
`;

export const GET_TOTAL_UNLOCKED_QUESTIONS_REGISTRIES_COUNT = gql`
    query GetUnlockedQuestionRegistriesCount($getUnlockedQuestionRegistriesCount: CompanyIdInput!) {
        getUnlockedQuestionRegistriesCount(getUnlockedQuestionRegistriesCount: $getUnlockedQuestionRegistriesCount) {
            count
        }
    }
`;

export const GET_TOTAL_QUESTION_LOCKED_QUESTION_REGISTRIES = gql`
    query GetLockedQuestionRegistriesCount($getLockedQuestionRegistriesCount: CompanyIdInput!) {
        getLockedQuestionRegistriesCount(getLockedQuestionRegistriesCount: $getLockedQuestionRegistriesCount) {
            count
        }
    }
`;

/**GET KANBAN BOARD LIST */
export const GET_KANBAN_BOARD_LIST = gql`
    query GetKanbanBoardQuestionV2($enquiryListInput: KanbanBoardEnquiryQuestionListInput!) {
        getKanbanBoardQuestionV2(enquiryListInput: $enquiryListInput) {
            kanbanBoardStatus
            showCloseConfirmationDialog
            items {
                _id
                addedToRegistry
                archivedBy
                audio
                companyId
                enquiryType
                boardStatus
                boardPriority
                createdAt
                announcementInfo {
                    announcementId
                    announcementTitle
                    attachment
                    attachmentTitle
                    pageNumber
                }
                assignees {
                    _id
                    firstName
                    lastName
                    profileImage
                    userName
                }
                enquiryCategories {
                    hoverCategoryColor
                    createdBy
                    companyId
                    categoryColor
                    _id
                    textColor
                    name
                }
                investor {
                    _id
                    email
                    firstName
                    lastName
                    investorStatus
                    mobileNum
                    userName
                }
                investorId
                isGuest
                lockedTime
                question
                rating
                resolvedBy
                status
                subject
                isDeletedInvestor
                isRemovedCompany
            }
            meta {
                currentPage
                itemCount
                itemsPerPage
                totalItems
                totalPages
            }
        }
    }
`;
/**Get classical enquiry list view query */
export const GET_CLASSICAL_ENQUIRY_LIST_VIEW_QUERY = gql`
    query GetEnquiryQuestions($enquiryListInput: EnquiryQuestionListInput!) {
        getEnquiryQuestions(enquiryListInput: $enquiryListInput) {
            items {
                _id
                addedToRegistry
                archivedBy
                audio
                companyId
                createdAt
                enquiryType
                enquiryResponse {
                    _id
                    attachments
                    enquiryId
                    content
                    rating
                    title
                }
                announcementInfo {
                    announcementId
                    announcementTitle
                    attachment
                    attachmentTitle
                    pageNumber
                }
                investor {
                    _id
                    email
                    firstName
                    investorStatus
                    lastName
                    mobileNum
                    userName
                }
                isGuest
                investorId
                lockedTime
                question
                rating
                resolvedBy
                status
                subject
                assignees {
                    _id
                    firstName
                    lastName
                    profileImage
                    userName
                }
                enquiryCategories {
                    hoverCategoryColor
                    createdBy
                    companyId
                    categoryColor
                    _id
                    textColor
                    name
                }
                isDeletedInvestor
                isRemovedCompany
            }

            meta {
                currentPage
                itemCount
                itemsPerPage
                totalItems
                totalPages
            }
        }
    }
`;

/**Get Sample Question shown info */
export const GET_SAMPLE_QUESTION_SHOWN_INFO = gql`
    query GetSampleQuestionShownInfo {
        getSampleQuestionShownInfo {
            showSampleQuestionMessage
        }
    }
`;
export const GET_UPDATE_BOARD_NOTIFICATION = gql`
    subscription Subscription {
        boardUpdated {
            boardUpdates
            isUpdated
            enquiryCategories {
                hoverCategoryColor
                createdBy
                companyId
                categoryColor
                _id
                textColor
                name
            }
            enquiryId
            assignees {
                _id
                firstName
                lastName
                profileImage
                userName
            }
            isAssignees
            isEnquiryCategoryAdded
            assigneesList {
                _id
                firstName
                lastName
                profileImage
                userName
            }
            enquiryCategoriesList {
                hoverCategoryColor
                createdBy
                companyId
                categoryColor
                _id
                textColor
                name
            }
            enquiryIds
        }
    }
`;
/**Poll */
export const CREATE_POLL = gql`
    mutation CreatePoll($createPollInput: PollInput!) {
        createPoll(createPollInput: $createPollInput) {
            _id
            asxCode
            announcementId
            announcementType
            attachment
            attachmentDuration
            attachmentSize
            attachmentThumbnail
            attachmentTotalPages
            companyId
            createdAt
            deleted
            fromAsx
            isPinned
            media
            pollInfoData {
                durationDays
                durationHours
                durationMinutes
                remainingPollTime
                pollOptionsData {
                    id
                    option
                    voteCount
                }
                title
                totalVotes
                userVotes {
                    choosenOption
                    firstName
                    investorType
                    lastName
                }
            }
            publishedDate
            seenPercentage
            starred
            status
            title
            totalViews
            userId
        }
    }
`;

export const UPDATE_POLL = gql`
    mutation UpdatePoll($updatePollInput: PollEditInput!) {
        updatePoll(updatePollInput: $updatePollInput) {
            _id
            announcementId
            announcementType
            asxCode
            attachment
            attachmentDuration
            attachmentSize
            attachmentThumbnail
            attachmentTotalPages
            companyId
            createdAt
            deleted
            fromAsx
            isPinned
            media
            pollInfoData {
                durationDays
                durationHours
                durationMinutes
                pollOptionsData {
                    id
                    option
                    voteCount
                }
                remainingPollTime
                title
                totalVotes
                userVotes {
                    choosenOption
                    firstName
                    investorType
                    lastName
                }
            }
            publishedDate
            seenPercentage
            starred
            status
            title
            totalViews
            userId
        }
    }
`;
export const GET_ENGAGEMENT_LEVEL_V2 = gql`
    query GetEngagementLevelV2($engagementInput: EngagementInputV2!) {
        getEngagementLevelV2(engagementInput: $engagementInput) {
            investorSatisfactionSatisfied {
                changeInEngagementLevel
                data {
                    date
                    seenPercentage
                    totalSeen
                }
            }
            investorSatisfactionUnSatisfied {
                changeInEngagementLevel
                data {
                    date
                    seenPercentage
                    totalSeen
                }
            }
            announcementsViews {
                changeInEngagementLevel
                data {
                    date
                    seenPercentage
                    totalSeen
                }
            }
            announcementsViewsCurrent {
                changeInEngagementLevel
                data {
                    date
                    seenPercentage
                    totalSeen
                }
            }
            announcementsViewsPotential {
                changeInEngagementLevel
                data {
                    date
                    seenPercentage
                    totalSeen
                }
            }
            companyEngagement {
                changeInEngagementLevel
                data {
                    date
                    seenPercentage
                    totalSeen
                }
            }
            companyEngagementCurrent {
                changeInEngagementLevel
                data {
                    date
                    seenPercentage
                    totalSeen
                }
            }
            companyEngagementPotential {
                changeInEngagementLevel
                data {
                    date
                    seenPercentage
                    totalSeen
                }
            }
            investorData {
                changeInEngagementLevel
                data {
                    date
                    seenPercentage
                    totalSeen
                }
            }
            investorDataCurrent {
                changeInEngagementLevel
                data {
                    date
                    seenPercentage
                    totalSeen
                }
            }
            investorDataPotential {
                changeInEngagementLevel
                data {
                    date
                    seenPercentage
                    totalSeen
                }
            }
            investorSatisfaction {
                changeInEngagementLevel
                data {
                    date
                    seenPercentage
                    totalSeen
                }
            }
            sharePriceViews {
                changeInEngagementLevel
                data {
                    date
                    seenPercentage
                    totalSeen
                }
            }
        }
    }
`;

export const GET_ENQUIRY_REPLY_LIST_ENQUIRY_ID = gql`
    query GetEnquiryReplyList($enquiryListReplyInput: EnquiryReplyListInput!) {
        getEnquiryReplyList(enquiryListReplyInput: $enquiryListReplyInput) {
            items {
                _id
                audio
                companyId
                content
                createdAt
                attachments
                investor {
                    _id
                    firstName
                    profileImage
                    lastName
                    userName
                }
                rating
                responder {
                    _id
                    firstName
                    lastName
                    profileImage
                    userName
                }
                fromDiolog
            }
            meta {
                currentPage
                itemCount
                itemsPerPage
                totalItems
                totalPages
            }
        }
    }
`;

export const GET_UPCOMING_EVENT = gql`
    query GetUpcomingCompanyEvent($eventInput: CompanyEventUpcomingInput!) {
        getUpcomingCompanyEvent(eventInput: $eventInput) {
            upcomingEvent {
                _id
                allDay
                attachment
                companyId
                date
                description
                endDate
                deleted
                endTime
                eventAttendies
                eventSeenBy {
                    investorId
                    seenAt
                }
                isHoliday
                location
                publishedDate
                startTime
                title
                userId
            }
        }
    }
`;
/**Investor sentiment query */
export const GET_INVESTOR_SENTIMENT_QUERY = gql`
    query GetInvestorSentimentSummary {
        getInvestorSentimentSummary {
            insights
            keywords
            satisfiedPercentage
            feelings
        }
    }
`;
export const GET_DATA_FOR_EXPORTING_PDF = gql`
    query GetEnquiryQuestionsForExportingPdf($exportEnquiryPdfInput: EnquiryExportPdfInput!) {
        getEnquiryQuestionsForExportingPdf(exportEnquiryPdfInput: $exportEnquiryPdfInput) {
            message
        }
    }
`;
export const GET_EXPORT_CSV_ENGAGEMENT_DATA_NEW = gql`
    query GetEngagementLevelChartsDataForCSV($chartEngamentLevelCsvInput: EngagementCSVInput!) {
        getEngagementLevelChartsDataForCSV(chartEngamentLevelCsvInput: $chartEngamentLevelCsvInput) {
            announcementsData {
                data {
                    current
                    currentSatisfied
                    currentUnsatisfied
                    potential
                    date
                    potientialSatisfied
                    potientialUnsatisfied
                    total
                    totalSatisfied
                    totalUnstatisfied
                }
                dataBreakDown {
                    _id
                    date
                    firstName
                    investorStatus
                    lastName
                    rating
                    title
                }
            }
            companyEngagementData {
                data {
                    current
                    currentSatisfied
                    currentUnsatisfied
                    date
                    potential
                    potientialSatisfied
                    total
                    totalSatisfied
                    totalUnstatisfied
                    potientialUnsatisfied
                }
                dataBreakDown {
                    _id
                    date
                    firstName
                    investorStatus
                    lastName
                    rating
                    title
                }
            }
            investorData {
                data {
                    current
                    currentSatisfied
                    currentUnsatisfied
                    date
                    potential
                    potientialSatisfied
                    potientialUnsatisfied
                    total
                    totalSatisfied
                    totalUnstatisfied
                }
                dataBreakDown {
                    _id
                    date
                    firstName
                    lastName
                    rating
                    title
                    investorStatus
                }
            }
            investorSatisfactionData {
                data {
                    current
                    currentUnsatisfied
                    currentSatisfied
                    date
                    potential
                    potientialSatisfied
                    total
                    potientialUnsatisfied
                    totalSatisfied
                    totalUnstatisfied
                }
                dataBreakDown {
                    _id
                    date
                    firstName
                    investorStatus
                    lastName
                    rating
                    title
                }
            }
        }
    }
`;
export const getNote = gql`
    query GetNote($noteDetailInput: EnquiryNoteDetailInput!) {
        getNote(noteDetailInput: $noteDetailInput) {
            _id
            companyId
            currentEditsUsing
            createdBy
            description
            editedBy
            enquiryId
            locked
            editedTexts {
                editedBy
                editedText
                node
            }
        }
    }
`;

export const GET_AUTHORIZED_USERS = gql`
    query GetAuthorizedUsers {
        getAuthorizedUsers {
            data
        }
    }
`;

export const GET_MENUS = gql`
    query GetMenus {
        getMenus {
            type
            data
        }
    }
`;

export const VERIFY_EMAIL_STATUS = gql`
    query Query {
        verifyEmailStatus {
            companyId
            data
        }
    }
`;

export const GET_INIVITED_TEAM_MEMBERS = gql`
    query GetInvitedTeamMembers($teamMembersListInput: InvitedTeamMemberListInput!) {
        getInvitedTeamMembers(teamMembersListInput: $teamMembersListInput) {
            items {
                teamMemberId
                teamMember {
                    subscriptionStatus
                    verifiedAt
                    userName
                    subscriptionRenewable
                    _id
                    email
                    stripeCustomerId
                    registeredWithGoogle
                    receiveNotification
                    profileImage
                    plan
                    mobileNum
                    lastName
                    lastLoggedInAt
                    jobTitle
                    firstName
                    reinvitationSentAt
                }
                permissions {
                    name
                    allowed
                    acessType
                }
                teamMemberRole
                invitationAccepted
                jobTitleInCompany
                companyId
                companyCreator
            }
        }
    }
`;

/**Stock Market Data Queries */
export const GET_STOCK_PRICE = gql`
    query GetStockPrice($stockPriceInput: StockPriceInput!) {
        getStockPrice(stockPriceInput: $stockPriceInput) {
            symbol
            price
            change
            changePercent
            previousClose
            volume
            marketCap
            openPrice
            dayHigh
            dayLow
            week52High
            week52Low
            peRatio
            dividend
            dividendYield
            timestamp
            source
            currency
            exchange
        }
    }
`;

export const GET_STOCK_HISTORICAL_DATA = gql`
    query GetStockHistoricalData($historicalDataInput: StockHistoricalDataInput!) {
        getStockHistoricalData(historicalDataInput: $historicalDataInput) {
            symbol
            timeframe
            data {
                timestamp
                open
                high
                low
                close
                volume
                adjustedClose
            }
            meta {
                totalDataPoints
                startDate
                endDate
                interval
                source
            }
        }
    }
`;

export const GET_STOCK_INTRADAY_DATA = gql`
    query GetStockIntradayData($intradayDataInput: StockIntradayDataInput!) {
        getStockIntradayData(intradayDataInput: $intradayDataInput) {
            symbol
            interval
            data {
                timestamp
                open
                high
                low
                close
                volume
            }
            lastRefreshed
            timezone
            source
        }
    }
`;

export const GET_MULTIPLE_STOCK_PRICES = gql`
    query GetMultipleStockPrices($multipleStockInput: MultipleStockPricesInput!) {
        getMultipleStockPrices(multipleStockInput: $multipleStockInput) {
            stocks {
                symbol
                price
                change
                changePercent
                volume
                timestamp
                source
            }
            lastUpdated
            totalSymbols
        }
    }
`;

export const GET_STOCK_MARKET_STATUS = gql`
    query GetStockMarketStatus($marketStatusInput: MarketStatusInput!) {
        getStockMarketStatus(marketStatusInput: $marketStatusInput) {
            market
            status
            isOpen
            nextOpen
            nextClose
            timezone
            timestamp
        }
    }
`;

export const GET_COMPANY_STOCK_PROFILE = gql`
    query GetCompanyStockProfile($companyStockInput: CompanyStockProfileInput!) {
        getCompanyStockProfile(companyStockInput: $companyStockInput) {
            symbol
            companyName
            exchange
            sector
            industry
            description
            website
            employees
            marketCap
            peRatio
            dividendYield
            beta
            eps
            revenue
            grossProfit
            lastUpdated
        }
    }
`;

export const SEARCH_STOCKS = gql`
    query SearchStocks($searchInput: StockSearchInput!) {
        searchStocks(searchInput: $searchInput) {
            results {
                symbol
                name
                exchange
                type
                currency
                matchScore
            }
            totalResults
            query
        }
    }
`;

export const GET_STOCK_NEWS = gql`
    query GetStockNews($stockNewsInput: StockNewsInput!) {
        getStockNews(stockNewsInput: $stockNewsInput) {
            articles {
                title
                summary
                url
                source
                publishedAt
                sentiment
                relevanceScore
                symbols
                topics
            }
            meta {
                totalArticles
                itemsReturned
                currentPage
                totalPages
            }
        }
    }
`;

export const GET_WATCHLIST_STOCKS = gql`
    query GetWatchlistStocks($watchlistInput: WatchlistInput!) {
        getWatchlistStocks(watchlistInput: $watchlistInput) {
            watchlistId
            name
            description
            createdAt
            updatedAt
            stocks {
                symbol
                price
                change
                changePercent
                volume
                addedAt
                alertsEnabled
            }
            performance {
                totalValue
                totalChange
                totalChangePercent
                dayChange
                dayChangePercent
            }
        }
    }
`;

export const GET_STOCK_DATA = gql`
    query GetStockData($stockInput: StockDataInput!) {
        getStockData(stockInput: $stockInput) {
            symbol
            currentPrice
            change
            changePercent
            previousClose
            volume
            marketCap
            prices {
                timestamp
                price
                volume
            }
            meta {
                timeRange
                totalDataPoints
                startDate
                endDate
                source
                lastUpdated
            }
        }
    }
`;
